const priorityColors = {
  low: 'info',
  medium: 'warning',
  high: 'danger'
}

const stateColors = {
  draft: 'dark',
  'new': 'default',
  in_process: 'primary',
  done: 'success',
  rejected: 'danger',
  closed: 'success',
  cancelled: 'danger',
  contractor_definition: 'warning',
  completed: 'success',
}

const stateHexColors = {
  draft: '#262626',
  'new': '#b5b5b5',
  in_process: '#3498db',
  done: '#23d160',
  rejected: '#ff470f',
  closed: '#23d160',
  cancelled: '#ff470f',
  contractor_definition: '#ffdd57',
  completed: '#23d160',
}

export {
  priorityColors,
  stateColors,
  stateHexColors
}